var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWinter)?_c('Snowf',{attrs:{"amount":_vm.random(30, 50),"size":_vm.random(6, 10),"speed":_vm.random(1, 2.5),"wind":[-1, 0, 1][Math.round(_vm.random(0, 2))],"opacity":0.8,"swing":1,"image":require('@/images/snow.svg?url'),"zIndex":2147483647,"resize":false,"color":"#fff"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }